export function getTranslationsPage2(
  newNameCitizenshipDetails,
  localizedStrings,
) {
  newNameCitizenshipDetails.lastname.elementConfig.label =
    localizedStrings.applicationpage.legallastname;
  newNameCitizenshipDetails.firstname.elementConfig.label =
    localizedStrings.applicationpage.legalfirstname;
  newNameCitizenshipDetails.middlename.elementConfig.label =
    localizedStrings.applicationpage.legalmiddlename;
  newNameCitizenshipDetails.ses_preferredname.elementConfig.label =
    localizedStrings.applicationpage.preferredname;
  newNameCitizenshipDetails.usb_maidenname.elementConfig.label =
    localizedStrings.applicationpage.birthname;
  newNameCitizenshipDetails.usb_formername.elementConfig.label =
    localizedStrings.applicationpage.formername;
  newNameCitizenshipDetails.usb_visastatus.elementConfig.label =
    localizedStrings.applicationpage.citizenshipstatus;
  newNameCitizenshipDetails.usb_currentstudent.elementConfig.label =
    localizedStrings.applicationpage.usbstudent;
  newNameCitizenshipDetails._usb_countryofcitizenship_value.elementConfig.label =
    localizedStrings.applicationpage.countryofcitizenship;
  newNameCitizenshipDetails._usb_countryofbirth_value.elementConfig.label =
    localizedStrings.applicationpage.countryofbirth;
  newNameCitizenshipDetails.usb_passport.elementConfig.label =
    localizedStrings.applicationpage.passportno;
  newNameCitizenshipDetails.usb_passportexpirydate.elementConfig.label =
    localizedStrings.applicationpage.passportexiprydate;
  newNameCitizenshipDetails.usb_studypermitnumber.elementConfig.label =
    localizedStrings.applicationpage.studyandworkpermitno;
  newNameCitizenshipDetails.usb_studypermitissuedate.elementConfig.label =
    localizedStrings.applicationpage.studypermitissuedate;
  newNameCitizenshipDetails.usb_studypermitexpirydate.elementConfig.label =
    localizedStrings.applicationpage.studypermitexpirationdate;
  newNameCitizenshipDetails.usb_visastatus.elementConfig.options =
    newNameCitizenshipDetails.usb_visastatus.elementConfig.options.map(
      (option) => {
        if (option.value === 943240000) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.canadiancitizen,
          };
        } else if (option.value === 943240001) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.permanentresident,
          };
        } else if (option.value === 943240002) {
          return {
            ...option,
            displayValue:
              localizedStrings.applicationpage.nonresidentworkpermit,
          };
        } else if (option.value === 943240003) {
          return {
            ...option,
            displayValue:
              localizedStrings.applicationpage.nonresidentstudypermit,
          };
        } else if (option.value === 943240004) {
          return {
            ...option,
            displayValue:
              localizedStrings.applicationpage.nonresidentstudypermitminnesota,
          };
        } else if (option.value === 943240005) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.refugee,
          };
        } else if (option.value === 943240006) {
          return {
            ...option,
            displayValue:
              localizedStrings.applicationpage.nonresidentnostudypermit,
          };
        }
        return option;
      },
    );
newNameCitizenshipDetails.usb_previouslyapplied.elementConfig.label =
    localizedStrings.applicationpage.haveyouappliedusb;
  newNameCitizenshipDetails.usb_mostrecentpreviousapplicationyear.elementConfig.label =
    localizedStrings.applicationpage.mostrecentyear;

  newNameCitizenshipDetails.usb_previouslyapplied.elementConfig.options =
    newNameCitizenshipDetails.usb_previouslyapplied.elementConfig.options.map(
      (option) => {
        if (option.value === true) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.yes,
          };
        } else if (option.value === false) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.no,
          };
        }
        return option;
      },
    );
  newNameCitizenshipDetails.usb_currentstudent.elementConfig.options =
    newNameCitizenshipDetails.usb_currentstudent.elementConfig.options.map(
      (option) => {
        if (option.value === true) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.yes,
          };
        } else if (option.value === false) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.no,
          };
        }
        return option;
      },
    );
  return newNameCitizenshipDetails;
}
export function getTranslationsPage2Address(
  newAddressContactDetails,
  localizedStrings,
) {
  newAddressContactDetails._ses_countryofresidence_value.elementConfig.label =
    localizedStrings.applicationpage.country;
  newAddressContactDetails.address1_line1.elementConfig.label =
    localizedStrings.applicationpage.street;
  newAddressContactDetails.address1_line2.elementConfig.label =
    localizedStrings.applicationpage.streetapt;
  newAddressContactDetails.address1_city.elementConfig.label =
    localizedStrings.applicationpage.city;
  newAddressContactDetails.ses_stateorprovince.elementConfig.label =
    localizedStrings.applicationpage.stateprovince;
  newAddressContactDetails.address1_postalcode.elementConfig.label =
    localizedStrings.applicationpage.postalcode;
  newAddressContactDetails.emailaddress1.elementConfig.label =
    localizedStrings.applicationpage.email;
  newAddressContactDetails.emailaddress3.elementConfig.label =
    localizedStrings.applicationpage.emailaddress2;
  return newAddressContactDetails;
}


export function getTranslationsPage2Telephone(
  newTelephoneDetails,
  localizedStrings,
) {
  newTelephoneDetails.mobilephone.elementConfig.label =
    localizedStrings.applicationpage.mobile;
  newTelephoneDetails.home2.elementConfig.label =
    localizedStrings.applicationpage.home;
  newTelephoneDetails.business2.elementConfig.label =
    localizedStrings.applicationpage.office;

  newTelephoneDetails.ses_optinfortextmessages.elementConfig.aboveText =
    localizedStrings.applicationpage.optinfortextmessages1;
  newTelephoneDetails.ses_optinfortextmessages.elementConfig.options =
    newTelephoneDetails.ses_optinfortextmessages.elementConfig.options.map(
      (option) => {
        if (option.value === true) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.yes,
          };
        } else if (option.value === false) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.no,
          };
        }
        return option;
      },
    );
  
  return newTelephoneDetails;
}
